(function() {
  const Toast = {
    _events: [],
    subscribe(callback) {
      this._events.push(callback);
    },
    publish(data) {
      this._events.forEach(callback => callback(data));
    },
    show({ message, type = 'success', duration = 2500 }) {
      const toast = document.createElement('div');
      toast.textContent = message;

      toast.style.cssText = `
        position: fixed;
        bottom: 2.4rem;
        right: 2.4rem;
        z-index: 9999999;
        width: 100%;
        max-width: 300px;
        background-color: ${type === "success" ? "#14ad00" : "#D10200"};
        padding: 1.2rem 1.6rem;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        transition: all 0.2s ease;
        transform: translateY(1.6rem);
        opacity: 0;
        font-size: 1.4rem;
        font-weight: 700;
        line-height: 1.8rem;
        letter-spacing: 0px;
        color: #ffffff;
      `;

      document.body.appendChild(toast);

      requestAnimationFrame(() => {
        toast.style.opacity = "1";
        toast.style.transform = "translateY(0)";
      });

      setTimeout(() => {
        toast.style.opacity = "0";
        toast.style.transform = "translateY(1.6rem)";
        setTimeout(() => toast.remove(), 100);
      }, duration);
    }
  };

  Toast.subscribe(function(data) {
    Toast.show(data);
  });

  window.Toast = {
    notify(options) {
      Toast.publish(options);
    }
  };
})();